// extracted by mini-css-extract-plugin
export default {"check":"CheckEmail_check__Vwifh","check__title":"CheckEmail_check__title__Jrf53","check__descr":"CheckEmail_check__descr__uPKzi"};